import { render, staticRenderFns } from "./TotalInternalReflectionViz.vue?vue&type=template&id=4f165955&scoped=true"
import script from "./TotalInternalReflectionViz.vue?vue&type=script&lang=js"
export * from "./TotalInternalReflectionViz.vue?vue&type=script&lang=js"
import style0 from "./TotalInternalReflectionViz.vue?vue&type=style&index=0&id=4f165955&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f165955",
  null
  
)

export default component.exports